export { install } from './sentry-installer';
